import { AppSettings } from '../constants';
import Jwt from '../helper/interceptors';
import { ObjToParam, MapResponse } from '../helper/helper-api';

let API_URI = AppSettings.CURRENT_SITE_URI;
let api = 'api';

//check admin or builder, true is admin
if (AppSettings.CURRENT_SITE_URI === AppSettings.SITE_ONE_SERVICE_URI) {
  API_URI = AppSettings.GLOBAL_API_URL;
  api = 'apiv1';
}

export const searchCostCodes = params => {
  return Jwt(API_URI)
    .get(`/${api}/cost-codes/search?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const createCostCode = params => {
  return Jwt(API_URI)
    .post(`/${api}/cost-codes`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const editCostCode = params => {
  return Jwt(API_URI)
    .put(`/${api}/cost-codes/${params.id}`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getCostCodeSelectList = () => {
  return Jwt(API_URI, false)
    .get(`/${api}/cost-codes/selectListItems`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const makeActive = params => {
  return Jwt(API_URI)
    .put(`/api/cost-codes/${params.id}/active`, {})
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const makeInActive = params => {
  return Jwt(API_URI)
    .put(`/api/cost-codes/${params.id}/inactive`, {})
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};



// WEBPACK FOOTER //
// ./src/CostCodes/api.js